<template>
  <div class="app">
    <Loading :value="loading"></Loading>
    <!-- RACOURCIS -->
    <v-card>
      <v-card-title>
        <v-breadcrumbs icons divider="chevron_right">
          <v-breadcrumbs-item
            icons
            router
            :to="item.path"
            v-for="item in racourcis"
            :key="item.text"
            :disabled="item.disabled"
          >
            {{ item.text }}</v-breadcrumbs-item
          >
        </v-breadcrumbs>
      </v-card-title>
    </v-card>
    <br />

    <!--Ligne 1 -->
    <v-layout row>
      <v-card style="width:100%">
        <v-card-text fluid grid-list-md>
          <h2>LISTE DES DEMANDES DE FONDS</h2>
          <v-divider class="mb-3"></v-divider>

          <!-- BTN AJOUT -->
          <v-layout row>
            <v-flex class="mb-1 " xs4 md4>
              <v-card-text class="text-xs-center">
                <v-chip
                  label
                  outline
                  color="orange darken-1"
                  class="elevation-4"
                  style="width:100%"
                >
                  <span class="subheading">Montant Total: </span>
                  <span class="title"> {{ mntTotal }} Fcfa </span>
                </v-chip>
              </v-card-text>
            </v-flex>

            <v-flex class="mb-1 " xs4 md4>
              <v-card-text class="">
                <v-chip
                  color="orange"
                  text-color="white"
                  style="font-size:18px"
                >
                  <v-avatar class="orange darken-4">{{ totalDmd }}</v-avatar>
                  Demandes
                </v-chip>
              </v-card-text>
            </v-flex>
          </v-layout>

          <v-spacer></v-spacer>
          <div class="text-xs-right mb-3">
            <v-tooltip top v-if="droitAcces.create_demande_fond">
              <v-btn
                slot="activator"
                icons
                color="primary"
                @click.stop="modalAjoutDmd()"
                dark
                >Ajouter une demande <v-icon right>playlist_add</v-icon></v-btn
              >
              Effectuer une demande de fonds
            </v-tooltip>
            <v-tooltip top v-if="droitAcces.imprimer_liste_demandeFond">
              <v-btn
                slot="activator"
                color="orange"
                @click.stop="imprimeDemandePDF()"
                dark
              >
                Imprimer
                <v-icon right> print</v-icon>
              </v-btn>
              Imprimer la liste des demandes
            </v-tooltip>
          </div>
          <v-layout row> </v-layout>

          <div class="text-xs-right ">
            <el-select
              filterable
              clearable
              @clear="clearSelect()"
              @change="filtrerCaisseDmd"
              v-model="selectCaisseDmd"
              placeholder="Selectionner une caisse"
            >
              <el-option
                v-for="item in listeCaisse"
                :key="item.id"
                :label="item.libelle"
                :value="item.id"
              >
              </el-option>
            </el-select>

            <el-select
              clearable
              @clear="clearSelect()"
              @change="filtrerEtatDmd"
              v-model="selectEtatDmd"
              placeholder="Selectionner le statut"
            >
              <el-option
                v-for="item in listeStatut"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <data-tables :data="listeDemandes">
            <el-table-column prop="dateFormat" label="Date"> </el-table-column>
            <el-table-column
              prop="demandeur"
              label="Nom du demandeur"
            ></el-table-column>
            <el-table-column prop="montantFormat" label="Montant (Fcfa)">
            </el-table-column>
            <el-table-column prop="libStatut" label="Statut">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.statut == 0" type="danger">
                  {{ scope.row.libStatut }}</el-tag
                >
                <el-tag v-if="scope.row.statut == 1">{{
                  scope.row.libStatut
                }}</el-tag>
                <el-tag v-if="scope.row.statut == 2" type="info">{{
                  scope.row.libStatut
                }}</el-tag>
                <el-tag v-if="scope.row.statut == 3" type="success">{{
                  scope.row.libStatut
                }}</el-tag>
                <el-tag v-if="scope.row.statut == 4" type="success">{{
                  scope.row.libStatut
                }}</el-tag>
                <el-tag v-if="scope.row.statut == 5" type="info">{{
                  scope.row.libStatut
                }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="caissePaie" label="Caisse paiement">
              <template slot-scope="scope">
                <el-tag type="info">{{ scope.row.caissePaie }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="carte" label="Carte">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.carte" type="info">{{
                  scope.row.carte
                }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column label="Action" align="center" fixed="right">
              <template slot-scope="scope">
                <v-tooltip top>
                  <v-btn
                    slot="activator"
                    @click="modalImpDmd(scope.row)"
                    fab
                    dark
                    small
                    color="grey"
                  >
                    <v-icon dark>list</v-icon>
                  </v-btn>
                  Detail
                </v-tooltip>
                <v-tooltip top>
                  <v-btn
                    v-show="scope.row.statut == 1 || scope.row.statut == 5"
                    slot="activator"
                    @click.stop="
                      itemDmd = scope.row;
                      dialogSupr = true;
                    "
                    fab
                    dark
                    small
                    color="red"
                  >
                    <v-icon dark>delete</v-icon>
                  </v-btn>
                  Supprimer
                </v-tooltip>
              </template>
            </el-table-column>
          </data-tables>
        </v-card-text>
      </v-card>
    </v-layout>

    <!-- MODAL SUPPRESSION DEMANDE -->
    <v-dialog v-model="dialogSupr" persistent max-width="50%">
      <v-card>
        <v-card-title class="headline"
          >Supprimer cet enregistrement ?</v-card-title
        >
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 class="mb-2">
              <el-alert
                title="La suppression est définitive"
                :closable="false"
                show-icon
                type="error"
              >
              </el-alert>
            </v-flex>
            <v-flex xs12>
              <p class="grey--text font-weight-thin body-1">DEMANDE</p>
              <p class="black--text .font-weight-regular subheading">
                DMD-{{ itemDmd.id }}
              </p>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" dark @click="dialogSupr = false"
            >Annuler <v-icon right>remove_circle</v-icon></v-btn
          >
          <v-btn color="red darken-1" dark @click="deleteDmd()"
            >Supprimer <v-icon right>delete</v-icon></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- MODAL SUPPRESSION DEMANDE -->

    <!-- Ajout zone maintenance -->
    <AjoutDemandeFond
      :editForm="editFormDmd"
      :dmdDetail="dmdDetail"
      :show="showModalAjoutDmd"
      @close="
        showModalAjoutDmd = false;
        loadDemande();
      "
    ></AjoutDemandeFond>
    <!-- Ajout zone maintenance -->

    <!-- Detail de la demande de fonds -->
    <ModalValidationDmdFond
      :valider="false"
      :logistique="false"
      :demandeDetail="demandeDetailFond"
      :show="showModalDetailDmdFond"
      @close="showDialogDmdFondAfter"
    ></ModalValidationDmdFond>
    <!-- Detail de la demande de maintenance -->
  </div>
</template>

<script>
import AjoutDemandeFond from "@/components/demandeFond/AjoutDemandeFond";
import ModalValidationDmdFond from "@/components/validationDG/ModalValidationDmdFond";

import Loading from "@/components/Loading";

export default {
  components: { Loading, AjoutDemandeFond, ModalValidationDmdFond },
  name: "DemandeFondIndex",
  data() {
    return {
      //data general
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      racourcis: [
        { path: "/", text: "Accueil", disabled: false },
        { path: "/demandeFond", text: "Demande de fonds", disabled: true }
      ],

      listeDemandes: [],
      oldListDemandes: [],
      legendeDmd: "",
      selectCaisseDmd: "",
      listeCaisse: [],
      selectEtatDmd: "",
      listeStatut: [],
      showModalDetailDmdFond: false,
      listeStatut: [
        {
          label: "refusé",
          value: 0
        },
        {
          label: "en attente de validation par le DG",
          value: 1
        },

        {
          label: "paiement en attente",
          value: 2
        },
        {
          label: "paiement effectué",
          value: 3
        }
      ],

      //ajout demande
      showModalAjoutDmd: false,
      dmdDetail: {},
      editFormDmd: false,
      demandeDetailFond: {},
      dialogSupr: false,
      itemDmd: {},
      mntTotal: 0,
      totalDmd: 0,
      //champs recherche
      searchListeDmd: ""
    };
  },

  methods: {
    imprimeDemandePDF() {
      let tab = [];
      this.listeDemandes.forEach(function(demande) {
        tab.push(demande.id);
      });

      let url = this.domaine + "demandeFond/imprimerPDF/liste/" + tab;
      window.open(url);
    },

    loadCaisse() {
      let url = this.domaine + "caisse/index";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listeCaisse = response.body.caisse;
        }
      });
    },

    deleteDmd() {
      this.loading = true;
      let url = this.domaine + "demandeFond/delete/" + this.itemDmd.id;
      this.$http.get(url).then(
        response => {
          this.loading = false;

          this.$notify({
            title: "SUPPRESSION",
            message: "Demande supprimée avec succès.",
            type: "success",
            position: "top-center"
          });
          this.dialogSupr = false;

          this.loadDemande();
        },
        errRep => {
          this.loading = false;
          this.dialogSupr = false;
          this.$notify.error({
            title: "SUPPRESSION ECHOUEE",
            message: "La suppression de la demande a échouée.",
            position: "top-center"
          });
        }
      );
    },
    modalAjoutDmd() {
      // this.loadCaisse()
      this.editFormDmd = false;
      this.showModalAjoutDmd = true;
    },
    modalEditDmd(item) {
      this.editFormDmd = true;
      this.dmdDetail = item;
      this.showModalAjoutDmd = true;
    },

    clearSelect() {
      this.listeDemandes = this.oldListDemandes;
      this.legendeDmd = "LISTE DES DEMANDES DE FONDS";
    },

    filtrerCaisseDmd(idCaisse) {
      this.loadDmdParCaisse(idCaisse);
    },

    filtrerEtatDmd(idEtat) {
      this.loadDmdParEtat(idEtat);
    },

    loadDmdParEtat(idEtat) {
      this.listeDemandes = this.oldListDemandes;
      this.selectCaisseDmd = null;
      this.listeDemandes = this.listeDemandes.filter(function(item) {
        return item.statut == idEtat;
      });
    },

    loadDmdParCaisse(idCaisse) {
      this.listeDemandes = this.oldListDemandes;
      this.selectEtatDmd = null;
      this.listeDemandes = this.listeDemandes.filter(function(item) {
        return item.idCaisse == idCaisse;
      });
    },
    loadDemande() {
      this.loading = true;
      let url = "";
      if (this.droitAcces.liste_demande_fond) {
        url = this.domaine + "demandeFond/index";
      } else {
        url = this.domaine + "demandeFond/index/fond/" + this.user.id;
      }

      this.$http.get(url).then(
        response => {
          this.loading = false;
          this.listeDemandes = response.body.listeDemandes;
          this.oldListDemandes = response.body.listeDemandes;
          this.mntTotal = response.body.montantTotal;
          //affichage nombre de demande
          this.totalDmd = this.listeDemandes.length;
          let totalDmdCour = this.listeDemandes.filter(function(element) {
            return element.statut == 1;
          });
          this.totalDmdCour = totalDmdCour.length;
        },
        response => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement des demandes de fonds"
          );
        }
      );
    },
    showDialogDmdFondAfter(idDmd, type) {
      this.showModalDetailDmdFond = false;
    },
    modalImpDmd(item) {
      this.demandeDetailFond = item;
      this.showModalDetailDmdFond = true;
    }
  },

  mounted() {
    this.loadDemande();
    this.loadCaisse();
  }
};
</script>

<style scoped>
.toolbar_content {
  height: 37px;
}
</style>



// WEBPACK FOOTER //
// src/components/demandeFond/Demande_fond_index.vue